<template>
  <div>
    <div class="text1">Oops... Page Under Development..!</div>
    <div class="center-screen">
      <v-img class="img-size" :src="imageSrc" alt="Under Development" contain></v-img>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnderDevelopment',
  data() {
    return {
      imageSrc: require('@/assets/under_developement.jpg')
    };
  }
};
</script>

<style scoped>
.img-size {
  width: 555px;
  height: 305px;
}

.text1 {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  color: red;
  margin-bottom: 16px;
}

.center-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
</style>
